export default [
    {
        title: 'مدیریت رکوردداران',
        icon: 'bx bx-award',
        children: [
            {
                title: 'رکوردداران',
                route: { name: 'hero' },
                resource: 'HeroManagment',
                action: 'show',
            },
            {
                title: 'نظرات رکوردداران',
                route: { name: 'herocomment' },
                resource: 'HeroComment',
                action: 'show',
            },
        ]

    }
]